import { render, staticRenderFns } from "./immersionHead.vue?vue&type=template&id=6d665c3e&scoped=true&"
import script from "./immersionHead.vue?vue&type=script&lang=js&"
export * from "./immersionHead.vue?vue&type=script&lang=js&"
import style0 from "./immersionHead.vue?vue&type=style&index=0&id=6d665c3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d665c3e",
  null
  
)

export default component.exports